import React from 'react';
import { MonitorTask } from '../../services/klineMonitorService';
import SignalItem from './SignalItem';
import { ORDER_SIDE } from '@/services/enums';

interface SignalListProps {
  symbol: string;
  monitorData: MonitorTask | null;
  onEditClick: () => void;
}

const SignalList: React.FC<SignalListProps> = ({ symbol, monitorData, onEditClick }) => {
  const data = monitorData as any;
  const buySignals = data?.signals
    ? data.signals.filter((s: any) => s.type === ORDER_SIDE.BUY)
    : data?.monitorRules?.buySignals || [];

  const sellSignals = data?.signals
    ? data.signals.filter((s: any) => s.type === ORDER_SIDE.SELL)
    : data?.monitorRules?.sellSignals || [];

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-bold text-white">监控信号</h3>
        <button
          onClick={onEditClick}
          className="flex items-center gap-2 px-3 py-1.5 text-xs bg-white/5 hover:bg-white/10 text-white/60 hover:text-white/90 border border-white/10 hover:border-white/20 rounded transition-colors"
          title="编辑AI响应数据"
        >
          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
            />
          </svg>
          编辑
        </button>
      </div>

      <div className="space-y-4 max-h-[60vh] overflow-y-auto custom-scrollbar pr-2">
        {!buySignals.length && !sellSignals.length && (
          <div className="text-center text-white/40 py-8">暂无监控信号</div>
        )}

        {buySignals.map((signal: any, index: number) => (
          <SignalItem
            key={`buy-${index}`}
            symbol={symbol}
            signal={{ ...signal, type: ORDER_SIDE.BUY }}
            monitorData={monitorData}
          />
        ))}

        {sellSignals.map((signal: any, index: number) => (
          <SignalItem
            key={`sell-${index}`}
            symbol={symbol}
            signal={{ ...signal, type: ORDER_SIDE.SELL }}
            monitorData={monitorData}
          />
        ))}
      </div>
    </div>
  );
};

export default SignalList;
